//
// js-cycler.js
//

import find_ancestor from "../helpers/find-ancestor";

const e = {};

function add_active_classes(el) {
  if (!el) return;

  let active_classes = el.getAttribute("data-js-cycler-active-classes");
  if (active_classes) {
    active_classes = active_classes.split(/[ ,]+/).filter(Boolean);
    el.classList.add(...active_classes);
  } else {
    el.classList.add("js-cycler-active");
  }
}

function remove_active_classes(el) {
  if (!el) return;

  let active_classes = el.getAttribute("data-js-cycler-active-classes");
  if (active_classes) {
    active_classes = active_classes.split(/[ ,]+/).filter(Boolean);
    el.classList.remove(...active_classes);
  } else {
    el.classList.remove("js-cycler-active");
  }
}

function add_inactive_classes(el) {
  if (!el) return;

  let inactive_classes = el.getAttribute("data-js-cycler-inactive-classes");
  if (inactive_classes) {
    inactive_classes = inactive_classes.split(/[ ,]+/).filter(Boolean);
    el.classList.add(...inactive_classes);
  } else {
    el.classList.add("js-cycler-inactive");
  }
}

function remove_inactive_classes(el) {
  if (!el) return;

  let inactive_classes = el.getAttribute("data-js-cycler-inactive-classes");
  if (inactive_classes) {
    inactive_classes = inactive_classes.split(/[ ,]+/).filter(Boolean);
    el.classList.remove(...inactive_classes);
  } else {
    el.classList.remove("js-cycler-inactive");
  }
}

function set_item_index(el, cycler_i) {
  if (Array.prototype.indexOf.call(e.cyclers[cycler_i].clickers, el) !== -1) {
    return Array.prototype.indexOf.call(e.cyclers[cycler_i].clickers, el);
  }
  return Array.prototype.indexOf.call(e.cyclers[cycler_i].paginators, el);
}

function hide_all(cycler_i) {
  if (e.cyclers[cycler_i].paginators.length) {
    Array.from(e.cyclers[cycler_i].paginators).forEach((el) =>
      remove_active_classes(el)
    );
    Array.from(e.cyclers[cycler_i].paginators).forEach((el) =>
      add_inactive_classes(el)
    );
  }

  if (e.cyclers[cycler_i].clickers.length) {
    Array.from(e.cyclers[cycler_i].clickers).forEach((el) =>
      remove_active_classes(el)
    );
    Array.from(e.cyclers[cycler_i].clickers).forEach((el) =>
      add_inactive_classes(el)
    );
  }

  Array.from(e.cyclers[cycler_i].items).forEach((el) =>
    remove_active_classes(el)
  );
  Array.from(e.cyclers[cycler_i].items).forEach((el) =>
    add_inactive_classes(el)
  );
}

function show(cycler_i, slide_i) {
  hide_all(cycler_i);

  if (e.cyclers[cycler_i].paginators.length) {
    add_active_classes(e.cyclers[cycler_i].paginators[slide_i]);
    remove_inactive_classes(e.cyclers[cycler_i].paginators[slide_i]);
  }

  if (e.cyclers[cycler_i].clickers.length) {
    add_active_classes(e.cyclers[cycler_i].clickers[slide_i]);
    remove_inactive_classes(e.cyclers[cycler_i].clickers[slide_i]);
  }

  add_active_classes(e.cyclers[cycler_i].items[slide_i]);
  remove_inactive_classes(e.cyclers[cycler_i].items[slide_i]);
}

function cb_click(ev) {
  const cycler = find_ancestor(ev.currentTarget, "js-cycler");
  const cycler_i = Array.prototype.indexOf.call(e.cycler_els, cycler);

  e.cyclers[cycler_i].current_item_i = set_item_index(
    ev.currentTarget,
    cycler_i
  );
  show(cycler_i, e.cyclers[cycler_i].current_item_i);

  if (e.cyclers[cycler_i].auto_cycle) {
    stop_cycling(cycler_i);
    start_cycling(cycler_i);
  }
}

// Cycling
// ------------------------------------

function stop_cycling(i) {
  clearInterval(e.cyclers[i].cycle_interval);
}

function start_cycling(i) {
  if (!e.cyclers[i].initialised) {
    return;
  }
  stop_cycling(i);
  e.cyclers[i].cycle_interval = setInterval(() => {
    show_next(i);
  }, e.cyclers[i].slide_duration);
}

function show_next(i) {
  if (++e.cyclers[i].current_item_i >= e.cyclers[i].items.length) {
    e.cyclers[i].current_item_i = 0;
  }
  show(i, e.cyclers[i].current_item_i);
}

function init_single_cycler(el, i) {
  e.cyclers[i] = {};
  e.cyclers[i].cycler = el;
  e.cyclers[i].clickers = el.getElementsByClassName("js-cycler__clicker");
  e.cyclers[i].paginators = el.getElementsByClassName("js-cycler__paginator");
  e.cyclers[i].items = el.getElementsByClassName("js-cycler__item");
  e.cyclers[i].item_count = e.cyclers[i].items.length;
  e.cyclers[i].initialised = true;
  e.cyclers[i].current_item_i = 0;
  e.cyclers[i].cycle_interval = null;
  e.cyclers[i].slide_duration = parseInt(
    el.getAttribute("data-js-cycler-slide-duration"),
    10
  );
  e.cyclers[i].auto_cycle = Number.isInteger(e.cyclers[i].slide_duration);

  if (e.cyclers[i].clickers.length) {
    Array.from(e.cyclers[i].clickers).forEach((clicker) =>
      clicker.addEventListener("click", cb_click)
    );
  }

  if (e.cyclers[i].paginators.length) {
    Array.from(e.cyclers[i].paginators).forEach((paginator) =>
      paginator.addEventListener("click", cb_click)
    );
  }

  if (e.cyclers[i].auto_cycle) {
    start_cycling(i);
  }
}

// Initialize
// ------------------------------------

function init() {
  e.cycler_els = document.getElementsByClassName("js-cycler");
  if (!e.cycler_els) {
    return;
  }
  e.cyclers = {};
  Array.from(e.cycler_els).forEach((el, i) => {
    init_single_cycler(el, i);
  });
}
init();
